import { Component, OnDestroy, OnInit, Renderer2, ElementRef, ViewChild, AfterViewInit} from '@angular/core';

// env
import { environment } from '../../../environments/environment';

// Service
import { GlobalService } from '../../shared/service/global.service';
import { ApiService } from '../../shared/service/api.service';

/* jquery */
declare var $: any;

/* plugin */
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit{
  
  @ViewChild('slickModalGal') slickModalGal: SlickCarouselComponent;
  @ViewChild('slickModalArticle') slickModalArticle: SlickCarouselComponent;
  slideGalleryConfig = {
    "slidesToShow": 3, 
    "autoplay": true,
    "arrows": false,
    "slidesToScroll": 3,
    "variableWidth": true,
    "responsive": [
      {
        "breakpoint": 900,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1
        }
      }
    ]
  };
  slideArticlesConfig = {
    "slidesToShow": 1, 
    "autoplay": false,
    "arrows": false,
    "rows": 2,
    "slidesPerRow": 2,
    "slidesToScroll": 1,
    "responsive": [
      {
        "breakpoint": 768,
        "settings": {
          "rows": 2,
          "slidesPerRow": 1
        }
      }
    ]
  };
  isLang;
  dataSliderBanner;
  dataAbout;
  dataAboutCur;
  dataAboutCurDesc;
  dataSustain;
  dataSustainCur;
  dataSustainCurDesc;
  dataBuilding;
  dataProduct;
  dataProductCur;
  dataProductCurDesc;
  dataAnnual;
  dataGallery;
  dataArticle;
  apiAsset = environment.API_ASSETS;

  constructor( private globalService : GlobalService, 
               private renderer: Renderer2, 
               private elem: ElementRef,
               private apiService: ApiService,
               private deviceService: DeviceDetectorService) {
    this.globalService.isLoading.next(true); 
  }

  ngOnInit() {
    // scroll gallery
    $(document).on('wheel', '.slide-gal', () => {
      $('.slide-gal').bind('mousewheel DOMMouseScroll', (e) => { 
        if (e.originalEvent.deltaY < 0) {
          this.slickModalGal.slickPrev();
        } else {
          this.slickModalGal.slickNext();
        }
        return false; 
      });
    });

    this.renderer.addClass(document.body, 'select-ver1');

    // MultiLanguage
    this.isLang = this.apiService.isLang();

    // Content
    this.apiService.getDataApi('getDataHome').subscribe(response => {
      // Banner Slider
      this.dataSliderBanner = response.data.slider;

      // About 
      this.dataAbout = response.data.about;
      this.dataAboutCur = response.data.about.content[0];
      this.dataAboutCurDesc = this.globalService.trimString2(response.data.about.content[0].metadesc, 85);

      // Sustainability
      this.dataSustain = response.data.sustainability;
      this.dataSustainCur = response.data.sustainability[0];
      this.dataSustainCurDesc = this.globalService.trimString2(response.data.sustainability[0].section.content, 150);

      // Fundamental
      this.dataBuilding = response.data.fundamental;

      // Products
      this.dataProduct = response.data.product;
      this.dataProductCur = response.data.product.content[0];
      this.dataProductCurDesc = this.globalService.trimString2(response.data.product.content[0].metadesc, 85);

      // Articles
      this.dataArticle = response.data.news_events;

      // Gallery
      this.dataGallery = response.data.gallery;

      // Meta
      this.globalService.updateMeta(
        'Home | PT Prime Agri Resources Tbk',
        'PT Prime Agri Resources Tbk, PT Prime Agri Resources Tbk homepage, homepage sagro',
        'PT Prime Agri Resources Tbk Homepage'
      );

      this.globalService.isLoading.next(false);
    });
  }

  ngAfterViewInit(){
    if(this.deviceService.isMobile()){
      if(this.isLandscape()){
        alert('Please use potrait mode for better experience');
      }
      $(window).on("orientationchange",function( event ){
          if(window.orientation === 90 || window.orientation === -90){
            alert('Please use potrait mode for better experience');
          }
      });
    }
  }

  isLandscape() {
    return (window.orientation === 90 || window.orientation === -90);
  }

  ngOnDestroy(){
    this.renderer.removeClass(document.body, 'select-ver1');
    /* clear select2 */
    const selectOptionsContainer = $('.select2-container');
    selectOptionsContainer.removeClass('select2-container--open');
  }

}
